// extracted by mini-css-extract-plugin
module.exports = {"Container":"Types_Container__1IHPV"};